export default __webpack_public_path__ + "static/media/groupMsg.6657f084.svg";